import { z } from 'zod/v4'

export const PaginationSchema = z.object({
  offset: z.number(),
  limit: z.number(),
  total: z.number().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional()
})
